import { FC, useState } from 'react';

import { Button, ButtonColor, DeviceInfoBlock } from 'shared';
import { Currency } from 'types/general.types';
import { formatCurrency } from 'utils/formatters';

import s21 from 'assets/images/S21.png';
import RootModalLayout from '../RootModalLayout';

import { List, ListItem, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { userBaseCurrencySelector } from 'store/slices/user-slice';
import { GetProductsData } from 'types/api/api-products.types';
import { getDomainAndSubdomain } from 'utils/domain';
import classes from './MinerDetailsModal.module.scss';

interface MinerDetailsModalProps {
  miner: GetProductsData.Product;
  nextStep: (miner: GetProductsData.Product, qty: number) => void;
  onClose: () => void;
}

export const MinerDetailsModal: FC<MinerDetailsModalProps> = ({ miner, onClose, nextStep }) => {
  const baseCurrency = useSelector(userBaseCurrencySelector) ?? Currency.USD;
  // const user = useSelector(userDataSelector);

  const [itemQuantity, setItemQuantity] = useState(1);
  // const [showNoApiImplemented, setShowNoApiImplemented] = useState(false);

  const { subdomain } = getDomainAndSubdomain();
  // const isPoolsPageAvailable =
  //   subdomain === 'cryptohall24-duerr' ||
  //   subdomain === 'cryptohall24-quetta' ||
  //   // subdomain === 'pantheon' ||
  //   // subdomain === 'pantheon-aus' ||
  //   subdomain === 'hearst' ||
  //   subdomain === 'avatron' ||
  //   subdomain === 'cryptotech' ||
  //   subdomain === 'paymine' ||
  //   subdomain === 'higgs';

  const showPromoInfo = subdomain === 'pantheon';

  const nextStepHandler = () => {
    // if (!user?.hasNicehashKey && !user?.hasViaBtcKey && isPoolsPageAvailable) {
    //   setShowNoApiImplemented(true);
    // } else {
    //   nextStep(miner, itemQuantity);
    // }
    nextStep(miner, itemQuantity);
  };

  // const closeNoApiImplemented = () => {
  //   setShowNoApiImplemented(false);
  // };

  // const moreInfoLink = (
  //   <OrangeLink to='#' text='More Info'>
  //     <CaretIcon className={classes.icon} />
  //   </OrangeLink>
  // );

  return (
    <>
      <RootModalLayout onClose={onClose} size='large' includeHeader={false}>
        <div className={classes.modalContent}>
          <div className={classes.imageColumn}>
            <img src={miner.imageUri ?? s21} alt={miner.model} className={classes.minerImage} />
          </div>
          <div className={classes.detailsColumn}>
            <DeviceInfoBlock quantity={itemQuantity} setItemQuantity={setItemQuantity} miner={miner} />
            {/* <div className={classes.addons}>
            <div className={classes.duckEnergy}>
              <div className={classes.info}>
                <Checkbox>Add DuckEnergy</Checkbox>
                <Typography variant='subtitle1' className={classes.explanation}>
                  $9 monthly per device
                </Typography>
              </div>
              {moreInfoLink}
            </div>

            <div className={classes.insurance}>
              <div className={classes.info}>
                <Checkbox>Add Insurance</Checkbox>
                <Typography variant='subtitle2' className={classes.explanation}>
                  3% of the insured value per miner per year as fee
                </Typography>
              </div>
              {moreInfoLink}
            </div>
          </div> */}
            <List sx={{ listStyleType: 'disc', pl: 4 }}>
              <ListItem sx={{ display: 'list-item' }}>
                <Typography component='span'>Location: {miner?.location || 'N/A'}</Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <Typography component='span'>Condition: {miner?.condition || 'N/A'}</Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <Typography component='span'>Availability: {miner?.orderType || 'N/A'}</Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <Typography component='span'>Net. kWh price: {miner?.electricitySellingPrice || 'N/A'}</Typography>
              </ListItem>
            </List>

            {showPromoInfo && (
              <List sx={{ listStyleType: 'disc', pl: 4 }}>
                <ListItem sx={{ display: 'list-item' }}>
                  <Typography component='span'>Spot electricity fluctuations covered unless exceeding 10%</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                  <Typography component='span'>3 month delivery time</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                  <Typography component='span'>
                    Price per miner: €8,750 (including CAPEX, cooling, transport & taxes)
                  </Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                  <Typography component='span'>40% due today</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                  <Typography component='span'>50% after constructions</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                  <Typography component='span'>10% when online</Typography>
                </ListItem>
              </List>
            )}
            <div className={classes.totalBlock}>
              <div className={classes.total}>
                <div className={classes.total_main}>
                  <Typography variant='h4' className={classes.totalText}>
                    Total amount
                  </Typography>
                  {showPromoInfo && <small>(First 40% due today)</small>}
                </div>
                <Typography variant='h3' className={classes.totalPrice}>
                  {formatCurrency(baseCurrency, miner.price * itemQuantity)}
                </Typography>
              </div>
              {/* <p className={classes.additionalText}>$8.74 per TH/s</p> */}
            </div>
            <Button
              color={ButtonColor.SECONDARY}
              className={classes.button}
              disabled={miner.soldOut}
              onClick={!miner.soldOut ? nextStepHandler : undefined}
            >
              Buy
            </Button>
          </div>
        </div>
      </RootModalLayout>
      {/* {showNoApiImplemented && <NoApiImplementedModal isModalOpen onClose={closeNoApiImplemented} />} */}
    </>
  );
};
